<template>
  <card>
    <!-- Card header -->
    <h3 slot="header" class="mb-0">New Safety Observation Priority</h3>
    <div class="text-right">
    </div>
    <form class="needs-validation"
          @submit.prevent="submit">

      <div class="form-row">
        <b-col md="8">
          <base-input label="Safety Observation Priority"
                      name="Safety Observation Priority"
                      placeholder="Safety Observation Priority"
                      v-model="model.safety_observation_priority_name" required>
          </base-input>
        </b-col>

        <b-col md="4">
          <base-input label="Safety Observation Priority Duration"
                      name="Safety Observation Priority Duration"
                      type="number"
                      placeholder=0
                      v-model="model.safety_observation_priority_duration" required>
          </base-input>
        </b-col>
      </div>

      <div class="form-row">
        <b-col md="4">
          <b-form-checkbox
            id="Active-Status"
            v-model="model.active_status"
            name="Active-Status"
            value="1"
            unchecked-value="0">
            <b>Active Status</b>
          </b-form-checkbox>
        </b-col>
      </div>
      <br>

      <base-button type="primary" @click="createData()">Create New Safety Observation Priority</base-button>
      <base-button type="primary" @click="$router.back()">Cancel</base-button>
      <!-- <div>
        <br>
        <h5 class="text-danger"> Note : <br><br>
                <i>
                1. By Default all Date is set to "TODAY.
                </i>
                <br>
                <i>
                2. Developer Progress % is set to "0 %" By Default.
                </i>
        </h5>
      </div> -->
    </form>
  </card>
</template>
<script>
  import BaseSlider from '@/components/BaseSlider'
  import {LoginURL, clientId, clientSecret, apiDomain, getHeader, getcurrentDate} from '@/assets/js/config.js'
  import axios from 'axios'
  import ErrorFunctionMixin from '@/assets/js/errorFunctionMix.js'

  export default {
    mixins: [ErrorFunctionMixin],
    components: {
      BaseSlider
    },
    created()
    {
      var currentDate = getcurrentDate()
    },
    data() {
      return {
        model: {
          safety_observation_priority_name: null,
          safety_observation_priority_duration: 0,
          active_status: 1,
        },
        abc: '100',
      }
    },
    methods: {
      createData(){
        if ( !this.model.safety_observation_priority_name || this.model.safety_observation_priority_duration == 0 )
        {
          
          if ( !this.model.safety_observation_priority_name ){
            this.$notify({
              message:
                '<b>Invalid Input : All Column are Mandatory in Create New Safety Observation Priority </b> - These field are required.',
              timeout: 10000,
              icon: 'ni ni-bulb-61',
              type: 'danger',
            });

          } else if ( this.model.safety_observation_priority_duration == 0 ) {
            this.$notify({
              message:
                '<b>Invalid Input : All Column are Mandatory in Create New Safety Observation Priority </b> - These field are required.',
              timeout: 10000,
              icon: 'ni ni-bulb-61',
              type: 'danger',
            });
          } else {
            this.$notify({
              message:
                '<b>Invalid Input : Safety Observation Priority Duration cannot be 0 </b>',
              timeout: 10000,
              icon: 'ni ni-bulb-61',
              type: 'danger',
            });
          }
        }
        else
        {
          axios.post(apiDomain + 'setup/safety_observation_priority', this.model, { headers: getHeader() })
          .then ( response => {
            if (response.status === 200)
            {
                this.$notify({
                message:
                  '<b>New Safety Observation Priority: ' + this.model.safety_observation_priority_name + '</b> - Successfully Created.',
                timeout: 10000,
                icon: 'ni ni-bell-55',
                type: 'default',
                });
                this.$router.back()
            }
          })
          .catch ( error => {
            console.log(error.response.data.errors)
            this.errorFunction(error, "Create New Safety Observation Priority")
          });
        }
      },
    }
  }
</script>
<style>
</style>
